export function useAboutShellBehavior() {
  return {
    contentClassName: "page-content page-content--about page-content--about-rebuild"
  };
}
